var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_351_634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7368 7H1.73682C1.18454 7 0.736816 7.44772 0.736816 8C0.736816 8.55228 1.18454 9 1.73682 9H15.7368C16.2891 9 16.7368 8.55228 16.7368 8C16.7368 7.44772 16.2891 7 15.7368 7Z",
    fill: "#637381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.73682 4.33325H15.7368C16.2891 4.33325 16.7368 3.88553 16.7368 3.33325C16.7368 2.78097 16.2891 2.33325 15.7368 2.33325H1.73682C1.18454 2.33325 0.736816 2.78097 0.736816 3.33325C0.736816 3.88553 1.18454 4.33325 1.73682 4.33325Z",
    fill: "#637381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7368 11.6665H1.73682C1.18454 11.6665 0.736816 12.1142 0.736816 12.6665C0.736816 13.2188 1.18454 13.6665 1.73682 13.6665H15.7368C16.2891 13.6665 16.7368 13.2188 16.7368 12.6665C16.7368 12.1142 16.2891 11.6665 15.7368 11.6665Z",
    fill: "#637381"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_351_634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.736816)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBurger);
export default __webpack_public_path__ + "static/media/menu-burger.7e74e36d79eaf40ced74d8b923303cac.svg";
export { ForwardRef as ReactComponent };